import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import type { JunctionMovementCountsDto } from "@/api/generated/models/junctionMovementCountsDto";
import { JunctionMovementCards } from "@/components/ui/junctionMovementCards/JunctionMovementCards";
export const JunctionsViewOverlay = t0 => {
  const $ = _c(5);
  const {
    selectedJunctionId,
    vehicleCountsData,
    selectedMovementId,
    onSelectMovement,
    onClose
  } = t0;
  if (selectedJunctionId === null || !vehicleCountsData) {
    return null;
  }
  let t1;
  if ($[0] !== onClose || $[1] !== onSelectMovement || $[2] !== selectedMovementId || $[3] !== vehicleCountsData) {
    t1 = <Box position="absolute" top="24" right="4" zIndex="4" data-testid="junction-movement-cards-overlay"><JunctionMovementCards data={vehicleCountsData} selectedMovementId={selectedMovementId} onSelectMovement={onSelectMovement} onClose={onClose} /></Box>;
    $[0] = onClose;
    $[1] = onSelectMovement;
    $[2] = selectedMovementId;
    $[3] = vehicleCountsData;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};